var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "search-input-wrapper" },
    [
      _c(
        "md-field",
        { staticClass: "input-group search-input-group" },
        [
          _c("md-input", {
            staticClass: "form-control search-input",
            attrs: {
              type: "text",
              id: "search-input",
              name: "searchtext",
              "aria-label": "Search Products, Suppliers...",
              autocomplete: "off"
            },
            on: {
              keyup: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.hit.apply(null, arguments)
              },
              keydown: [
                function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "down", 40, $event.key, [
                      "Down",
                      "ArrowDown"
                    ])
                  ) {
                    return null
                  }
                  return _vm.down.apply(null, arguments)
                },
                function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "up", 38, $event.key, [
                      "Up",
                      "ArrowUp"
                    ])
                  ) {
                    return null
                  }
                  return _vm.up.apply(null, arguments)
                },
                function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.addApiUrls()
                },
                function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "esc", 27, $event.key, [
                      "Esc",
                      "Escape"
                    ])
                  ) {
                    return null
                  }
                  return _vm.reset.apply(null, arguments)
                }
              ],
              input: _vm.inputHandler
            },
            model: {
              value: _vm.query,
              callback: function($$v) {
                _vm.query = $$v
              },
              expression: "query"
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.hasItems,
                  expression: "hasItems"
                }
              ],
              staticClass: "search-typeahead"
            },
            [
              _c(
                "ul",
                _vm._l(_vm.items, function(item, $item) {
                  return _c(
                    "li",
                    {
                      class: _vm.activeClass($item),
                      on: {
                        mousedown: _vm.hit,
                        mousemove: function($event) {
                          return _vm.setActive($item)
                        }
                      }
                    },
                    [
                      _c("span", {
                        staticClass: "name",
                        domProps: { innerHTML: _vm._s(item.SupplierName) }
                      })
                    ]
                  )
                }),
                0
              )
            ]
          ),
          _vm._v(" "),
          _vm.items.length === 0 && _vm.query.length > 2
            ? _c("div", { staticClass: "search-typeahead" }, [
                _c("ul", [_c("li", [_c("span", [_vm._v("No results found")])])])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "form-control-placeholder",
              attrs: { for: "search-input" }
            },
            [_vm._v("Search Products, Suppliers...")]
          ),
          _vm._v(" "),
          _vm.query != "" && _vm.query != null
            ? _c("span", { staticClass: "input-group-btn search-clear" }, [
                _c("input", {
                  staticClass: "icon-close submit-input",
                  attrs: { type: "submit", value: "" },
                  on: {
                    click: function($event) {
                      return _vm.clearSearch()
                    }
                  }
                })
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("span", { staticClass: "input-group-btn search-submit" }, [
            _c("input", {
              staticClass: "icon-search submit-input",
              attrs: { type: "submit", value: "search" },
              on: {
                click: function($event) {
                  return _vm.addApiUrls()
                }
              }
            })
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7c4206db", { render: render, staticRenderFns: staticRenderFns })
  }
}